import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';

export type TimerStatus = 'idle' | 'running' | 'stopped' | 'finished';

/**
 * Timer state broadcast by the main app server.
 * remainingMs is computed server-side at emit time; clients derive a local
 * deadline (receivedAt + remainingMs) and count down locally.
 */
export interface TimerStatePayload {
  enabled: boolean;
  status: TimerStatus;
  durationMs: number;
  remainingMs: number;
}

export interface TimerControlCommand {
  action: 'set' | 'start' | 'stop' | 'reset';
  durationMs?: number;
}

export interface TimerState extends TimerStatePayload {
  receivedAt: number; // local Date.now() when the state was received
}

const initialState: TimerState = {
  enabled: false,
  status: 'idle',
  durationMs: 120000,
  remainingMs: 120000,
  receivedAt: 0,
};

const timerSlice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    setTimerState: (state, action: PayloadAction<TimerState>) => {
      return action.payload;
    },
  },
});

export const { setTimerState } = timerSlice.actions;

export const selectTimer = (state: RootState) => state.timer;

export default timerSlice.reducer;
